import { createFileRoute } from '@tanstack/react-router'
import { useAuthStore } from '@/features/auth/stores/auth.store'
import { unauthenticatedRedirect } from '@/app/router/route-guards'
import { MainLayout } from '@/components/layout'

/**
 * Pathless layout route guarding all authenticated pages. Unauthenticated
 * visitors are bounced to the external web client (or /login in dev).
 */
export const Route = createFileRoute('/_auth')({
  beforeLoad: () => {
    if (!useAuthStore.getState().isAuthenticated) {
      throw unauthenticatedRedirect()
    }
  },
  component: MainLayout,
})
